<template>
  <Row type="flex" :gutter="30">
    <Col
      v-if="orderType === 'both' || orderType === 'buy'"
      :xs="{ span: 24 }"
      :lg="{ span: 12 }"
    >
      <Form ref="buyForm" :model="buy">
        <FormItem>
          <label class="before" :style="inputLabelStyle">{{ $t("exchange.buyPrice") }}</label>
          <Input
            disabled
            :placeholder="$t('exchange.buyTip')"
            class="market-price-pre"
          >
            <span slot="prepend">
              {{ currentCoin.base }}
            </span>
          </Input>
          <!--          <label class="after">{{ currentCoin.base }}</label>-->
        </FormItem>
        <FormItem prop="marketAmount">
          <label class="before" :style="inputLabelStyle">{{ $t("exchange.buyAmount") }}</label>
          <Input
            @on-keyup="handleMarketBuy"
            v-model="buy.marketAmount"
            placeholder="0"
          >
            <span slot="prepend">
              {{ currentCoin.base }}
            </span>
          </Input>
          <!--          <label class="after">{{ currentCoin.base }}</label>-->
        </FormItem>
        <FormItem class="slider-wrap mb-11" prop="sliderPercent">
          <Slider
            class="slider-buy"
            v-model="buy.sliderPercent"
            :step="1"
            show-tip="always"
            :tip-format="tipFormat"
            :disabled="buySliderDisabled"
            @on-change="handleBuySlider"
          ></Slider>
          <div
            class="slider-stop"
            :class="{ 'slider-stop-enable': !buySliderDisabled }"
            v-for="item in sliderStep"
            :key="`${item}-buy`"
            :style="'left: ' + item + '%;'"
            @click="updateStepper('buy', item, buySliderDisabled)"
          >
            <div
              class="slider-block"
              :class="{ 'buy-slider-block-active': buy.sliderPercent > item }"
            ></div>
          </div>
        </FormItem>
        <Button
          :loading="loadingAskMarketButton"
          :disabled="!enableMarketBuy || !isExchangeable || noBaseCoins"
          class="pt-2 pb-2 text-white fill-width font-Regular-12"
          :class="
            enableMarketBuy && isExchangeable && !noBaseCoins
              ? 'bg-green'
              : 'bg-gray'
          "
          @click="buyWithMarketPrice"
          >{{ $t("exchange.buy") }} ({{ currentCoin.coin }})
        </Button>
        <!--        <Button v-else class="bg-gray pt-2 pb-2 text-white fill-width font-Bold-13">-->
        <!--          {{ $t("exchange.buyin") }} ({{ currentCoin.coin }})-->
        <!--        </Button>-->
      </Form>
    </Col>

    <Col
      v-if="orderType === 'both' || orderType === 'sell'"
      :xs="{ span: 24 }"
      :lg="{ span: 12 }"
    >
      <Form ref="sellForm" :model="sell">
        <FormItem>
          <label class="before" :style="inputLabelStyle">{{ $t("exchange.sellPrice") }}</label>
          <Input
            disabled
            :placeholder="$t('exchange.sellTip')"
            class="market-price-pre"
          >
            <span slot="prepend">
              {{ currentCoin.base }}
            </span>
          </Input>
          <!--          <label class="after">{{ currentCoin.base }}</label>-->
        </FormItem>
        <FormItem prop="marketAmount">
          <label class="before" :style="inputLabelStyle">{{ $t("exchange.sellAmount") }}</label>
          <Input
            @on-keyup="handleMarketSell"
            v-model="sell.marketAmount"
            placeholder="0"
          >
            <span slot="prepend">
              {{ currentCoin.coin }}
            </span>
          </Input>
          <!--          <label class="after">{{ currentCoin.coin }}</label>-->
        </FormItem>
        <FormItem class="slider-wrap mb-11" prop="sliderPercent">
          <Slider
            class="silder-sell"
            v-model="sell.sliderPercent"
            :step="1"
            show-tip="always"
            :tip-format="tipFormat"
            :disabled="sellSliderDisabled"
            @on-change="handleSellSlider"
          ></Slider>
          <div
            class="slider-stop"
            :class="{ 'slider-stop-enable': !sellSliderDisabled }"
            v-for="item in sliderStep"
            :key="`${item}-sell`"
            :style="'left: ' + item + '%;'"
            @click="updateStepper('sell', item, sellSliderDisabled)"
          >
            <div
              class="slider-block"
              :class="{ 'sell-slider-block-active': sell.sliderPercent > item }"
            ></div>
          </div>
        </FormItem>
        <Button
          :loading="loadingBidMarketButton"
          :disabled="!enableMarketSell || !isExchangeable || noBaseCoins"
          class="pt-2 pb-2 text-white fill-width font-Regular-12"
          :class="
            enableMarketSell && isExchangeable && !noBaseCoins
              ? 'bg-red'
              : 'bg-gray'
          "
          @click="sellMarketPrice"
        >
          {{ $t("exchange.sell") }}
          ({{ currentCoin.coin }})
        </Button>
        <!--        <Button v-else class="bg-gray pt-2 pb-2 text-white fill-width font-Bold-13">-->
        <!--          {{ $t("exchange.sellout") }} ({{ currentCoin.coin }})-->
        <!--        </Button>-->
      </Form>
    </Col>
  </Row>
</template>

<script>
import { handleInput, removeThousand } from "@/utiles/numericValidations";
import { mapActions } from "vuex";

export default {
  name: "MarketOrderForm",
  props: {
    orderType: {
      type: String,
      required: true,
    },
    currentCoin: {
      type: Object,
      required: true,
    },
    baseCoinScale: {
      type: Number,
      required: true,
    },
    coinScale: {
      type: Number,
      required: true,
    },
    wallet: {
      type: Object,
      required: true,
    },
    enableMarketBuy: {
      type: Number,
      required: true,
    },
    enableMarketSell: {
      type: Number,
      required: true,
    },
    isExchangeable: {
      type: Boolean,
      required: true,
    },
    noBaseCoins: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      sell: {
        marketAmount: "",
        sliderPercent: 0,
      },
      buy: {
        marketAmount: "",
        sliderPercent: 0,
      },
      loadingAskMarketButton: false,
      loadingBidMarketButton: false,
      sliderStep: [25, 50, 75, 100],
      isUseBHB: false,
    };
  },
  watch: {
    "currentCoin.symbol"() {
      this.resetForms();
    },
  },
  computed: {
    sellSliderDisabled() {
      let account = this.wallet.coin;
      let min = this.toFloor(1 / Math.pow(10, this.coinScale));
      return account < min || !this.enableMarketSell || !this.isExchangeable;
    },
    buySliderDisabled() {
      let account = this.wallet.base;
      let min = this.toFloor(1 / Math.pow(10, this.baseCoinScale));
      return account < min || !this.enableMarketBuy || !this.isExchangeable;
    },
    inputLabelStyle() {
      return {
        right: this.isLocaleLTR ? '10px' : 'unset',
        left: this.isLocaleLTR ? 'unset' : '10px'
      };
    }
  },
  mounted() {
    this.resetForms();
  },
  methods: {
    ...mapActions({
      addOrder: "exchange/ADD_ORDER_SERVICE",
    }),
    resetForms() {
      if (this.orderType === "both") {
        this.$refs.buyForm.resetFields();
        this.$refs.sellForm.resetFields();
      } else {
        this.$refs[`${this.orderType}Form`].resetFields();
      }
    },
    updateStepper(key, val, disabled) {
      if (!disabled) {
        this[key].sliderPercent = val;
        if (key === "buy") this.handleBuySlider(val);
        else this.handleSellSlider(val);
      }
    },
    tipFormat(val) {
      return val + "%";
    },
    handleMarketBuy() {
      this.buy.marketAmount = handleInput(
        this.buy.marketAmount,
        this.baseCoinScale
      );
      this.buy.sliderPercent =
        parseFloat(this.buy.marketAmount) > 0 && this.wallet.base > 0
          ? removeThousand(this.buy.marketAmount).div(this.wallet.base).mul(100)
          : 0;
    },
    handleMarketSell() {
      this.sell.marketAmount = handleInput(
        this.sell.marketAmount,
        this.coinScale
      );
      this.sell.sliderPercent =
        parseFloat(this.sell.marketAmount) > 0 &&
        parseFloat(this.wallet.coin) > 0
          ? removeThousand(this.sell.marketAmount)
              .div(this.wallet.coin)
              .mul(100)
          : 0;
    },
    handleBuySlider(val) {
      this.buy.marketAmount = handleInput(
        this.wallet.base.mul(val).mul(0.01),
        this.baseCoinScale
      );
    },
    handleSellSlider(val) {
      this.sell.marketAmount = handleInput(
        this.wallet.coin.mul(val).mul(0.01),
        this.coinScale
      );
    },
    buyWithMarketPrice() {
      this.loadingAskMarketButton = true;
      const marketAmount = removeThousand(this.buy.marketAmount);

      if (marketAmount == "") {
        this.$toast.error(this.$t("exchange.enterBuyPrice"));
        this.loadingAskMarketButton = false;
        return;
      }
      if (marketAmount > parseFloat(this.wallet.base)) {
        this.$toast.error(this.$t("exchange.insufficientBalance"));
        this.loadingAskMarketButton = false;
        return;
      }
      let payload = {
        symbol: this.currentCoin.symbol,
        price: 0,
        amount: marketAmount,
        direction: "BUY",
        type: "MARKET_PRICE",
        useDiscount: this.isUseBHB ? "1" : "0", //whether to deduct the trial fee 0 not used 1 used
      };
      this.addOrder(payload)
        .then(() => {
          this.$toast.success(this.$t("exchange.success"));
          this.$emit("refresh");
          this.buy.sliderPercent = 0;
          this.buy.marketAmount = "";
        })
        .catch((err) => {
          this.$toast.success(err.message);
        })
        .finally(() => {
          this.loadingAskMarketButton = false;
        });
    },
    sellMarketPrice() {
      this.loadingBidMarketButton = true;
      const marketAmount = removeThousand(this.sell.marketAmount);

      if (marketAmount == "") {
        this.$toast.error(this.$t("exchange.enterSellAmount"));
        this.loadingBidMarketButton = false;
        return;
      }
      if (marketAmount > parseFloat(this.wallet.coin)) {
        this.$toast.error(this.$t("exchange.insufficientBalance"));
        this.loadingBidMarketButton = false;
        return;
      }
      let payload = {
        symbol: this.currentCoin.symbol,
        price: 0,
        amount: marketAmount,
        direction: "SELL",
        type: "MARKET_PRICE",
        useDiscount: this.isUseBHB ? "1" : "0", //whether to deduct the trial fee 0 not used 1 used
      };
      this.addOrder(payload)
        .then(() => {
          this.$toast.success(this.$t("exchange.success"));
          this.$emit("refresh");
          this.sell.sliderPercent = 0;
          this.sell.marketAmount = "";
        })
        .catch((err) => {
          this.$toast.error(err.message);
        })
        .finally(() => {
          this.loadingBidMarketButton = false;
        });
    },
  },
};
</script>

<style scoped></style>
